<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>

  <div class="col-lg-12">
    <div class="card">
      <div class="header d-flex justify-content-between align-items-center m-2 p-2">
        <b-button @click="logout" class="mb-3" variant="danger">
          Cerrar sesión
        </b-button>
        <h2><strong>Listado</strong> Usuarios</h2>
        <b-button @click="onNew" class="mb-3" variant="success" v-if="checkUserAdmin()">
          + Añadir
        </b-button>
      </div>
      <div class="body">
        <div class="table-responsive">
  <table class="table table-bordered table-striped table-hover dataTable js-exportable">
    <thead>
    <tr>
      <th>NOMBRE</th>
      <th>APELLIDOS</th>
      <th>EMAIL</th>
      <th>TIPO</th>
      <th>OPERACIONES</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="user of users" v-bind:key="user.id">
      <td>{{user.name}}</td>
      <td>{{user.lastName}}</td>
      <td>{{user.email}}</td>
      <td>{{user.type}}</td>
      <td>
        <button class="btn btn-info" style="margin-left: 20px;" @click="verUsuario(user.id, user.name, user.lastName, user.empresa, user.telefono, user.type, user.status, user.email, user.password,)">
          <i class="zmdi zmdi-hc-fw"></i>
        </button>
        <button v-if="checkUserAdmin() || myuser.id === user.id" class="btn btn-success" @click="editUsuario(user.id, user.name, user.lastName, user.empresa, user.telefono, user.type, user.status, user.email, user.password,)">
          <i class="zmdi zmdi-hc-fw"></i>
        </button>
        <button v-if="checkUserAdmin() && myuser.id !== user.id" class="btn btn-warning" @click="deleteusuario(user.id, )">
          <i class="zmdi zmdi-hc-fw"></i>
        </button>
      </td>
    </tr>
    </tbody>
  </table>
        </div>
      </div>
    </div>
  </div>

    <!-- Info modal -->
    <b-modal :id="infoModal.id" :title="infoModal.title" hide-footer>
       <div class="modal-body">
              <form @submit="formSubmit" enctype="multipart/form-data">
                      <label for="">Nombre</label>
                      <b-form-input
                        id="NOMBRE"
                        v-model="selectedItem.NOMBRE"
                        placeholder="Nombre.."
                        :state="($v.selectedItem.NOMBRE.$dirty && submitted)?
                        !$v.selectedItem.NOMBRE.$error : null"
                        aria-describedby="nombre-feedback"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback id="nombre-feedback">
                        Este campo es requerido.
                      </b-form-invalid-feedback>
                      <br>
                      <label for="">APELLIDO</label>
                      <b-form-input
                        id="APELLIDO"
                        v-model="selectedItem.APELLIDO"
                        placeholder="Apellido.."
                        :state="($v.selectedItem.APELLIDO.$dirty && submitted)?
                        !$v.selectedItem.APELLIDO.$error : null"
                        aria-describedby="apellido-feedback"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback id="nombre-feedback">
                        Este campo es requerido.
                      </b-form-invalid-feedback>
                      <br>
                      <label for="">EMPRESA</label>
                      <b-form-input
                        id="EMPRESA"
                        v-model="selectedItem.EMPRESA"
                        placeholder="Empresa.."
                        :state="($v.selectedItem.EMPRESA.$dirty && submitted)?
                        !$v.selectedItem.EMPRESA.$error : null"
                        aria-describedby="empresa-feedback"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback id="nombre-feedback">
                        Este campo es requerido.
                      </b-form-invalid-feedback>
                      <br>
                      <label for="">TELÉFONO</label>
                      <b-form-input
                        id="TELEFONO"
                        v-model="selectedItem.TELEFONO"
                        placeholder="Teléfono.."
                        :state="($v.selectedItem.TELEFONO.$dirty && submitted)?
                        !$v.selectedItem.TELEFONO.$error : null"
                        aria-describedby="telefono-feedback"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback id="telefono-feedback">
                        Este campo es requerido.
                      </b-form-invalid-feedback>
                      <br>
                      <label for="">EMAIL</label>
                      <b-form-input
                        id="EMAIL"
                        type="email"
                        v-model="selectedItem.EMAIL"
                        placeholder="Email.."
                        :state="($v.selectedItem.EMAIL.$dirty && submitted)?
                        !$v.selectedItem.EMAIL.$error : null"
                        aria-describedby="email-feedback"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback id="email-feedback">
                        Este campo es requerido.
                      </b-form-invalid-feedback>
                      <br>
                      <label for="">PASSWORD</label>
                      <b-form-input
                        id="PASSWORD"
                        type="password"
                        v-model="selectedItem.PASSWORD"
                        placeholder="Password.."
                        :state="($v.selectedItem.PASSWORD.$dirty && submitted)?
                        !$v.selectedItem.PASSWORD.$error : null"
                        aria-describedby="password-feedback"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback id="password-feedback">
                        Este campo es requerido.
                      </b-form-invalid-feedback>
                      <br>
                      <label for="">TIPO</label>
                      <b-form-select
                        id="TIPO"
                        v-model="selectedItem.TIPO"
                        :options="optionsSelectTipo"
                        class="mb-3"
                        value-field="value"
                        text-field="text"
                        :state="($v.selectedItem.TIPO.$dirty && submitted)?
                        !$v.selectedItem.TIPO.$error : null"
                        aria-describedby="tipo-feedback"
                      ></b-form-select>
                      <b-form-invalid-feedback id="tipo-feedback">
                        Este campo es requerido.
                      </b-form-invalid-feedback>
                      <br>

                  <div class="box-footer">
                    <br>
                      <button type="submit" class="btn btn-info">Guardar</button>
                      <a class="btn btn-default" @click="$bvModal.hide('info-modal')">Cancelar</a>
                  </div>
              </form>
       </div>
    </b-modal>

       <!--Modal para Editar un usuario-->
     <b-modal id="mdlEditarUsuario" title="Editar Usuario" hide-footer>
       <div class="modal-body">
              <form @submit="formSubmitEditarUsuario" enctype="multipart/form-data">
                      <label for="">Nombre</label>
                      <b-form-input
                        id="NOMBRE"
                        v-model="selectedItem.NOMBRE"
                        placeholder="Nombre.."
                        :state="($v.selectedItem.NOMBRE.$dirty && submittedModalEdit)?
                        !$v.selectedItem.NOMBRE.$error : null"
                        aria-describedby="nombre-feedback"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback id="nombre-feedback">
                        Este campo es requerido.
                      </b-form-invalid-feedback>
                      <br>
                      <label for="">APELLIDO</label>
                      <b-form-input
                        id="APELLIDO"
                        v-model="selectedItem.APELLIDO"
                        placeholder="Apellido.."
                        :state="($v.selectedItem.APELLIDO.$dirty && submittedModalEdit)?
                        !$v.selectedItem.APELLIDO.$error : null"
                        aria-describedby="apellido-feedback"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback id="apellido-feedback">
                        Este campo es requerido.
                      </b-form-invalid-feedback>
                      <br>
                      <label for="">EMPRESA</label>
                      <b-form-input
                        id="EMPRESA"
                        v-model="selectedItem.EMPRESA"
                        placeholder="Empresa.."
                        :state="($v.selectedItem.EMPRESA.$dirty && submittedModalEdit)?
                        !$v.selectedItem.EMPRESA.$error : null"
                        aria-describedby="empresa-feedback"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback id="empresa-feedback">
                        Este campo es requerido.
                      </b-form-invalid-feedback>
                      <br>
                      <label for="">TELÉFONO</label>
                      <b-form-input
                        id="TELEFONO"
                        v-model="selectedItem.TELEFONO"
                        placeholder="Teléfono.."
                        :state="($v.selectedItem.TELEFONO.$dirty && submittedModalEdit)?
                        !$v.selectedItem.TELEFONO.$error : null"
                        aria-describedby="telefono-feedback"
                      >
                      </b-form-input>

                      <br>
                      <label for="">EMAIL</label>
                      <b-form-input
                        id="EMAIL"
                        type="email"
                        v-model="selectedItem.EMAIL"
                        placeholder="Email.."
                        :state="($v.selectedItem.EMAIL.$dirty && submittedModalEdit)?
                        !$v.selectedItem.EMAIL.$error : null"
                        aria-describedby="email-feedback"
                      >
                      </b-form-input>
                      <b-form-invalid-feedback id="email-feedback">
                        Este campo es requerido.
                      </b-form-invalid-feedback>
                      <br>
                      <label for="">PASSWORD</label>
                      <b-form-input
                        id="PASSWORD"
                        type="password"
                        v-model="selectedItem.PASSWORD"
                        placeholder="Password.."
                      >
                      </b-form-input>
                      <br>
                      <label for="">TIPO</label>
                      <b-form-select
                        id="TIPO"
                        v-model="selectedItem.TIPO"
                        :options="optionsSelectTipo"
                        class="mb-3"
                        value-field="value"
                        text-field="text"
                      ></b-form-select>
                      <br>

                      <label for="">STATUS</label>
                      <b-form-select
                        id="STATUS"
                        v-model="selectedItem.STATUS"
                        :options="optionsSelect"
                        class="mb-3"
                        value-field="value"
                        text-field="text"
                      ></b-form-select>
                      <b-form-invalid-feedback id="status-feedback">
                        Este campo es requerido.
                      </b-form-invalid-feedback>
                      <br>

                  <div class="box-footer">
                    <br>
                      <button type="submit" class="btn btn-info">Editar Usuario</button>
                      <a class="btn btn-default"
                      @click="$bvModal.hide('mdlEditarUsuario')">Cancelar</a>
                  </div>
              </form>
       </div>
    </b-modal>

           <!--Modal para VER un usuario-->
     <b-modal id="mdlVerUsuario" title="Ver Usuario" hide-footer>
       <div class="modal-body">
                      <label for="">Nombre</label>
                      <b-form-input
                        id="NOMBRE"
                        v-model="selectedItem.NOMBRE"
                        placeholder="Nombre.."
                        :disabled=true
                      >
                      </b-form-input>

                      <br>
                      <label for="">APELLIDO</label>
                      <b-form-input
                        id="APELLIDO"
                        v-model="selectedItem.APELLIDO"
                        placeholder="Apellido.."
                        :disabled=true
                      >
                      </b-form-input>

                      <br>
                      <label for="">EMPRESA</label>
                      <b-form-input
                        id="EMPRESA"
                        v-model="selectedItem.EMPRESA"
                        placeholder="Empresa.."
                        :disabled=true
                      >
                      </b-form-input>

                      <br>
                      <label for="">TELÉFONO</label>
                      <b-form-input
                        id="TELEFONO"
                        v-model="selectedItem.TELEFONO"
                        placeholder="Teléfono.."
                        :disabled=true
                      >
                      </b-form-input>

                      <br>
                      <label for="">EMAIL</label>
                      <b-form-input
                        id="EMAIL"
                        type="email"
                        v-model="selectedItem.EMAIL"
                        placeholder="Email.."
                        :disabled=true
                      >
                      </b-form-input>

                      <br>
                      <label for="">TIPO</label>
                      <b-form-select
                        id="TIPO"
                        v-model="selectedItem.TIPO"
                        :options="optionsSelectTipo"
                        class="mb-3"
                        value-field="value"
                        text-field="text"
                      ></b-form-select>
                      <label for="">STATUS</label>
                      <b-form-select
                        id="STATUS"
                        v-model="selectedItem.STATUS"
                        :options="optionsSelect"
                        class="mb-3"
                        value-field="value"
                        text-field="text"
                        :disabled=true
                      ></b-form-select>
                      <b-form-invalid-feedback id="nombre-feedback">
                        Este campo es requerido.
                      </b-form-invalid-feedback>
                      <br>

                  <div class="box-footer">
                    <br>
                      <a class="btn btn-default"
                      @click="$bvModal.hide('mdlVerUsuario')">Cancelar</a>
                  </div>
       </div>
    </b-modal>
</div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import * as params from '../../../env';

export default {
  name: 'gridusers',
  data() {
    return {
      myuser: null,
      users: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      submitted: false,
      submittedModalEdit: false,
      optionsSelect: [
        { value: 1, text: 'Activo' },
        { value: '2', text: 'Inactivo' },
      ],
      optionsSelectTipo: [
        { value: 'E', text: 'Editor' },
        { value: 'E2', text: 'Editor Secundaria' },
        { value: 'V', text: 'Visor' },
        { value: 'V2', text: 'Visor Secundaria' },
        { value: 'A', text: 'Administrador' },
        { value: 'D', text: 'Developer' },
      ],
      selectedItem: {
        ID: null,
        NOMBRE: null,
        APELLIDO: null,
        EMPRESA: null,
        TELEFONO: null,
        EMAIL: null,
        PASSWORD: null,
        TIPO: null,
      },
    };
  },
  validations: {
    selectedItem: {
      NOMBRE: {
        required,
      },
      APELLIDO: {
        required,
      },
      EMPRESA: {
        required,
      },
      TELEFONO: {
        required,
      },
      EMAIL: {
        required,
      },
      PASSWORD: {
        required,
      },
      TIPO: {
        required,
      },
    },
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem(params.default.USER_STORAGE));
    this.myuser = user;

    this.getUsers();
  },
  methods: {
    async logout() {
      this.loading = true;

      try {
        await this.axios.post('auth/logout');
        this.loading = false;
        localStorage.removeItem('token');
        localStorage.removeItem(params.default.USER_STORAGE);
        this.$router.push('/login');
      } catch (e) {
        this.loading = false;
        localStorage.removeItem('token');
        localStorage.removeItem(params.default.USER_STORAGE);
        this.$router.push('/login');
      }
    },
    async getUsers() {
      this.loading = true;

      try {
        const response = await this.axios.get('user');
        this.users = response.data.data;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    onNew() {
      this.submitted = false;
      this.limpiar();
      this.infoModal.title = 'Crear usuarios';
      this.$root.$emit('bv::show::modal', this.infoModal.id);
    },
    limpiar() {
      this.selectedItem.ID = null;
      this.selectedItem.NOMBRE = null;
      this.selectedItem.APELLIDO = null;
      this.selectedItem.TELEFONO = null;
      this.selectedItem.EMPRESA = null;
      this.selectedItem.TIPO = null;
      this.selectedItem.EMAIL = null;
      this.selectedItem.PASSWORD = null;
      this.tag = '';
      this.tags = [];
    },
    editUsuario(IDp, NOMBREp, APELLIDOp, EMPRESAp, TELEFONOp, TIPOp, STATUSp, EMAILp, PASSWORDp) {
      this.selectedItem.ID = IDp;
      this.selectedItem.NOMBRE = NOMBREp;
      this.selectedItem.APELLIDO = APELLIDOp;
      this.selectedItem.EMPRESA = EMPRESAp;
      this.selectedItem.TELEFONO = TELEFONOp;
      this.selectedItem.EMAIL = EMAILp;
      this.selectedItem.PASSWORD = PASSWORDp;
      this.selectedItem.TIPO = TIPOp;

      this.selectedItem.STATUS = STATUSp;
      this.$root.$emit('bv::show::modal', 'mdlEditarUsuario');
    },
    verUsuario(IDp, NOMBREp, APELLIDOp, EMPRESAp, TELEFONOp, TIPOp, STATUSp, EMAILp, PASSWORDp) {
      this.selectedItem.ID = IDp;
      this.selectedItem.NOMBRE = NOMBREp;
      this.selectedItem.APELLIDO = APELLIDOp;
      this.selectedItem.EMPRESA = EMPRESAp;
      this.selectedItem.TELEFONO = TELEFONOp;
      this.selectedItem.EMAIL = EMAILp;
      this.selectedItem.PASSWORD = PASSWORDp;
      this.selectedItem.TIPO = TIPOp;
      this.selectedItem.STATUS = STATUSp;
      this.$root.$emit('bv::show::modal', 'mdlVerUsuario');
    },
    async deleteusuario(iduser) {
      const confirmation = await this.$bvModal.msgBoxConfirm('Esta a punto de eliminar el usuario ¿Esta seguro?');
      if (confirmation) {
        this.loading = true;
        const response = await this.axios.post('Usuarios/deleteusuario', { ID: iduser });
        if (response.data.status === 'success') {
          this.loading = false;
          this.$toasted.show('Se elimino el registro seleccionado.', { theme: 'outline', type: 'success', duration: 5000 });
          this.limpiar();
          this.getUsers();
        } else {
          this.loading = false;
          this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
        }
      }
    },
    async formSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.selectedItem.$touch();
      if (this.$v.selectedItem.NOMBRE.$invalid || this.$v.selectedItem.APELLIDO.$invalid
          || this.$v.selectedItem.EMPRESA.$invalid
          || this.$v.selectedItem.EMAIL.$invalid
          || this.$v.selectedItem.PASSWORD.$invalid
          || this.$v.selectedItem.TIPO.$invalid) {
        return;
      }
      this.loading = true;
      const config = {
        headers: { 'content-type': 'multipart/form-data' },
      };
      const formData = new FormData();
      formData.append('NOMBRE', this.selectedItem.NOMBRE);
      formData.append('APELLIDO', this.selectedItem.APELLIDO);
      formData.append('EMPRESA', this.selectedItem.EMPRESA);
      formData.append('TELEFONO', this.selectedItem.TELEFONO);
      formData.append('EMAIL', this.selectedItem.EMAIL);
      formData.append('PASSWORD', this.selectedItem.PASSWORD);
      formData.append('TIPO', this.selectedItem.TIPO);

      await this.axios.post('Usuarios', formData, config)
        .then((response) => {
          if (response.data.status === 'success') {
            this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
            this.$root.$emit('bv::hide::modal', this.infoModal.id);
            this.limpiar();
            this.getUsers();
          } else {
            this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
          }
          this.loading = false;
        });
    },
    async formSubmitEditarUsuario(e) {
      e.preventDefault();
      this.submittedModalEdit = true;
      this.$v.selectedItem.$touch();

      this.loading = true;
      const config = {
        headers: { 'content-type': 'multipart/form-data' },
      };
      const formData = new FormData();
      formData.append('ID', this.selectedItem.ID);
      formData.append('NOMBRE', this.selectedItem.NOMBRE);
      formData.append('APELLIDO', this.selectedItem.APELLIDO);
      formData.append('EMPRESA', this.selectedItem.EMPRESA);
      formData.append('TELEFONO', this.selectedItem.TELEFONO);
      formData.append('EMAIL', this.selectedItem.EMAIL);
      formData.append('PASSWORD', this.selectedItem.PASSWORD);
      formData.append('TIPO', this.selectedItem.TIPO);
      formData.append('STATUS', this.selectedItem.STATUS);

      await this.axios.post('Usuarios/editusuario', formData, config)
        .then((response) => {
          if (response.data.status === 'success') {
            this.$toasted.show('Los datos se guardaron satisfactoriamente.', { theme: 'outline', type: 'success', duration: 5000 });
            this.$root.$emit('bv::hide::modal', 'mdlEditarUsuario');
            this.limpiar();
            this.getUsers();
          } else {
            this.$toasted.show(response.data.message, { theme: 'outline', type: 'error', duration: 5000 });
          }
          this.loading = false;
        });
    },
  },
};
</script>
